var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarllenoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55_18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1341 16.1549L16.4413 6.9418L16.5053 3.07897H16.8156L16.8012 0.644257C24.2722 1.4873 30.0762 7.73215 30.0762 15.314C30.0762 21.9464 25.6368 27.5567 19.5238 29.4239L19.1341 16.1549Z",
    fill: "#EA3F38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.115848 15.314C0.115848 7.71238 5.94848 1.45436 13.4482 0.637665L13.4118 3.07896H13.6282L13.6812 6.94179L11.1165 16.1647L10.92 29.4953C4.67883 27.7071 0.115848 22.0375 0.115848 15.3151V15.314Z",
    fill: "#EA3F38"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55_18"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 29.2857,
    fill: "white",
    transform: "matrix(-1 0 0 1 30.0762 0.637665)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarllenoIcon);
export default __webpack_public_path__ + "static/media/barlleno-icon.8800da0a7f90bba50332336d57785b5b.svg";
export { ForwardRef as ReactComponent };